/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'Constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDashboardDetails: ( {startDate , endDate,userid,demoaccount_id,rideModel } ) => {
    return axios.get(API_ENDPOINTS.DASHBOARD, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
      },
      params: {
        startDate, // Query parameter for start date
        endDate,   // Query parameter for end date
 userid,    // Query parameter for user id
        demoaccount_id, // Query parameter for demo account id
rideModel
      },
    });
  },
 getChartData: ({ userid, months, demoaccount_id,rideModel }) => {
    return axios.get(API_ENDPOINTS.DASHBOARD_CHART, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
      },
      params: {
        userid,
        months,
      demoaccount_id,
rideModel
      },
    });
  },
}
